import React, { useState } from 'react';
import { apiFetch } from '../../../../apiFetch';
import './RefreshYoutubeVideos.css'; // ✅ External CSS for theming

const CHANNELS = {
    trainingVideos: {
        id: 'UC82ALhXKYfX4BtDrzm8oM3A',
        label: 'Training Videos'
    },
    vsnWorld: {
        id: 'UCwXdRTjP4RO3TFNfEEafDKw',
        label: 'VSN World'
    }
};

const RefreshYoutubeVideos = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const refreshChannel = async (channelId, label) => {
        setLoading(true);
        setMessage('');
        try {
            const response = await apiFetch(
                `/api/admin/refresh-videos?channelId=${encodeURIComponent(channelId)}`,
                { method: "POST" }
            );



            const data = await response.json();
            if (response.ok) {
                setMessage(`✅ ${label} refreshed successfully. ${data.count} videos stored.`);
            } else {
                setMessage(`❌ Error: ${data.error || 'Unknown error occurred.'}`);
            }
        } catch (err) {
            setMessage(`❌ Network error: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="refresh-container">
            <h2 className="refresh-title">Refresh YouTube Videos</h2>
            <p className="refresh-subtext">This is for refreshing YouTube video metadata for the two VSN channels.Limit the number of times you refresh to reduce API calls, only refresh when new videos have been posted on Youtube. The videos you refresh will be accessible to all users.</p>

            <div className="refresh-buttons">
                {Object.entries(CHANNELS).map(([key, { id, label }]) => (
                    <button
                        key={key}
                        onClick={() => refreshChannel(id, label)}
                        className="refresh-btn"
                        disabled={loading}
                    >
                        {loading ? 'Refreshing...' : `Refresh ${label}`}
                    </button>
                ))}
            </div>

            {message && (
                <div className={`refresh-message ${message.startsWith('✅') ? 'success' : 'error'}`}>
                    {message}
                </div>
            )}
        </div>
    );
};

export default RefreshYoutubeVideos;






